import React from "react";
import BrandComponents from "../../Masters/Brand/BrandComponents";

function PoTable() {

  let header = [
    { label: "Id", field: "id" },
    { label: "Status", field: "status" },
    { label: "PO Type", field: "potype" },
    { label: "PO Category", field: "pocategory" },
    { label: "PO No.", field: "pono" },
    { label: "Job Number", field: "jobnumber" },
    { label: "Supplier Company", field: "suppliercompanyname" },
    { label: "Warehouse", field: "warehousename" },
    { label: "Branch", field: "branchname" },
    { label: "PO Date", field: "podate" }, 
  ];

  return (
    <div>
      <BrandComponents
        header={header}
        tableTitle={"PURCHASE ORDER"}
        apiField={"purchaseOrder"}
        addButton={"+ ADD"}
        createRoute={"/poCreate"}
        updateRoute={"/poView"}
        viewRoute={"/poView"}
      />
    </div>
  );
}

export default PoTable;
